// Generated by purs version 0.15.0
import * as Data_Record from "../Data.Record/index.js";
import * as Restaumatic_Form from "../Restaumatic.Form/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var WithExtra = function (x) {
    return x;
};
var makeEmptyWithExtra = function (dictMakeEmpty) {
    return function (dictMakeEmpty1) {
        return {
            makeEmptyImpl: function (opts) {
                return function __do() {
                    var subform1 = Restaumatic_Form.makeEmptyImpl(dictMakeEmpty)(opts)();
                    var extra1 = Restaumatic_Form.makeEmptyImpl(dictMakeEmpty1)({
                        name: opts.name
                    })();
                    return {
                        subform: subform1,
                        extra: extra1
                    };
                };
            }
        };
    };
};
var isTextFieldWithExtra = function (dictIsTextField) {
    return {
        textInput: function (v) {
            return Restaumatic_Form.textInput(dictIsTextField)(v.subform);
        }
    };
};
var hasFieldWithExtraTrue = function () {
    return function (dictIsSymbol) {
        return {
            getFieldWithExtra: function (label) {
                return function (v) {
                    return function (v1) {
                        return Data_Record.getField(Data_Record.hasFieldRecord(dictIsSymbol)())(label)(v1.extra);
                    };
                };
            }
        };
    };
};
var hasFieldWithExtraFalse = function (dictHasField) {
    return {
        getFieldWithExtra: function (label) {
            return function (v) {
                return function (v1) {
                    return Data_Record.getField(dictHasField)(label)(v1.subform);
                };
            };
        }
    };
};
var dumpStateWithExtra = function (dictDumpState) {
    return function (dictDumpState1) {
        return {
            dumpState: function (v) {
                return Restaumatic_Form.dumpState(Restaumatic_Form.dumpState_Record()(Restaumatic_Form.dumpStateRecordCons({
                    reflectSymbol: function () {
                        return "extra";
                    }
                })(Restaumatic_Form.dumpStateRecordCons({
                    reflectSymbol: function () {
                        return "subform";
                    }
                })(Restaumatic_Form.dumpStateRecordNil)(dictDumpState)()())(dictDumpState1)()()))(v);
            }
        };
    };
};
var addContextWithExtra = function (dictAddContext) {
    return function (dictAddContext1) {
        return {
            addContext: function (ctx) {
                return function (v) {
                    return function __do() {
                        Restaumatic_Form.addContext(dictAddContext)(ctx)(v.subform)();
                        return Restaumatic_Form.addContext(dictAddContext1)(ctx)(v.extra)();
                    };
                };
            }
        };
    };
};
var subform = function (v) {
    return v.subform;
};
var hasErrorsWithExtra = function (dictHasErrors) {
    return {
        displayedErrors: function (f) {
            return Restaumatic_Form.displayedErrors(dictHasErrors)(subform(f));
        }
    };
};
var isSelectFieldWithExtra = function (dictIsSelectField) {
    return {
        selectWriteValue: function (f) {
            return Restaumatic_Form.selectWriteValue(dictIsSelectField)(subform(f));
        },
        selectReadValue: function (f) {
            return Restaumatic_Form.selectReadValue(dictIsSelectField)(subform(f));
        },
        selectGetOptions: function (f) {
            return Restaumatic_Form.selectGetOptions(dictIsSelectField)(subform(f));
        },
        selectTouch: function (f) {
            return Restaumatic_Form.selectTouch(dictIsSelectField)(subform(f));
        }
    };
};
var mergeWithExtra = function (dictMerge) {
    return {
        merge: function (d) {
            var $49 = Restaumatic_Form.merge(dictMerge)(d);
            return function ($50) {
                return $49(subform($50));
            };
        }
    };
};
var queryWithExtra = function (dictQuery) {
    return {
        queryWith: function (s) {
            var $51 = Restaumatic_Form.queryWith(dictQuery)(s);
            return function ($52) {
                return $51(subform($52));
            };
        }
    };
};
var getFieldWithExtra = function (dict) {
    return dict.getFieldWithExtra;
};
var hasFieldWithExtraRecord = function () {
    return function (dictHasFieldWithExtra) {
        return {
            getField: function (label) {
                return getFieldWithExtra(dictHasFieldWithExtra)(label)(Type_Proxy["Proxy"].value);
            }
        };
    };
};
var extra = function (v) {
    return v.extra;
};
export {
    getFieldWithExtra,
    WithExtra,
    subform,
    extra,
    hasFieldWithExtraRecord,
    hasFieldWithExtraTrue,
    hasFieldWithExtraFalse,
    makeEmptyWithExtra,
    queryWithExtra,
    mergeWithExtra,
    addContextWithExtra,
    dumpStateWithExtra,
    isSelectFieldWithExtra,
    hasErrorsWithExtra,
    isTextFieldWithExtra
};
//# sourceMappingURL=index.js.map
